import React from 'react'
import './uat-orders.css'
import MainContainer from "../../components/container/MainContainer";import Breadcrumb from '../../components/breadcrumb/Breadcrumb'
import BreadcrumbData from '../../utils/constants/BreadcrumbData.constants'
import Orders from '../../components/Orders/Orders'

const UATOrders: React.FunctionComponent = () => {

  return (
    <MainContainer>
      <Breadcrumb routes={BreadcrumbData.orders_summary} />
      <Orders />
    </MainContainer>
  )
}

export default UATOrders